import script from "./UserMailRenewalCode.vue?vue&type=script&setup=true&lang=js"
export * from "./UserMailRenewalCode.vue?vue&type=script&setup=true&lang=js"

import "./UserMailRenewalCode.vue?vue&type=style&index=0&id=75dc1a66&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75dc1a66"]])

export default __exports__